import { render, staticRenderFns } from "./TestPrepSelector.vue?vue&type=template&id=68136a68&"
import script from "./TestPrepSelector.vue?vue&type=script&lang=js&"
export * from "./TestPrepSelector.vue?vue&type=script&lang=js&"
import style0 from "./TestPrepSelector.vue?vue&type=style&index=0&id=68136a68&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports